<div class="bookConsultation">
  <div class="container-xl">
    <h1 class="f-p" data-aos="fade-up">
      {{ title }}
    </h1>
    <button
      type="button"
      data-aos="fade-up"
      class="primaryBtn border lg haveHoverBorder"
      (click)="bookConsult()">
      BOOK A CONSULTATION
    </button>
  </div>
</div>
